<template>
  <div class = "editor-textarea-new">
    <div id = "editor"></div>
    <div v-if = "false" class = "debug">{{outputDebug}}</div>
  </div>
</template>

<script>
/*
 * load Editor
 * then project will be loaded -> watcher gets current [tab].code
 * set a session if no existing otherwise retrieve it and use it
 * on write code use set [tab].code
 */
export default {
  name: 'EditorTextAreaAce',
  props: {
    project: Object
  },
  components: {
  },
  watch: {
    '$route': function (oldRoute, newRoute) {
      // console.log('changed route')
      this.sessions = []
    },
    'project': function (oldRoute, newRoute) {
      // console.log('changed project')
      this.sessions = []
    },
    tab (newTab, oldTab) {
      // change session
      // console.log('tabChanged', newTab, oldTab)
      if (newTab !== -1) this.setSession(newTab)
    },
    code (newCode, oldCode) {
      // console.log(newCode)
    },
    isMobile (state) {
      this.setMobileProperties(state)
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.editorConfig.isMobile
    },
    tab: {
      get: function () {
        // console.log('computed tab ', this.$store.state.editorConfig.tabSelected)
        return this.$store.state.editorConfig.tabSelected
      }
    },
    codefile: {
      get: function () {
        // console.log('watcher code', this.$store.getters.getSelectedTabCodefile)
        return this.$store.getters.getSelectedTabCodefile
      },
      set: function (newCode) {
        // console.log('2. commit', newCode)
        this.$store.commit('setCode', { projectId: this.project.id, code: newCode })
      }
    }
  },
  data () {
    return {
      sessions: {},
      editor: null,
      outputDebug: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initEditor()
    })
  },
  created () {
  },
  destroyed () {
    this.editor.remove()
  },
  methods: {
    setMobileProperties: function (state) {
      // console.log('isMobile ', state)
      if (state) {
        this.changeFontSize('14pt')
        this.editor.renderer.setShowGutter(false)
      } else {
        this.changeFontSize('16pt')
        this.editor.renderer.setShowGutter(true)
      }
    },
    changeFontSize: function (size) {
      this.editor.setFontSize(size)
    },
    initEditor: function () {
      var ace_ = ace
      this.editor = ace_.edit('editor')
      this.Range = ace_.require('ace/range').Range
      ace_.require('ace/lib/event')
      ace_.require('ace/config')
      ace_.require('ace/edit_session')
      ace_.require('ace/undomanager')
      ace_.require('ace/marker')
      ace_.require('ace/range')
      ace_.require('ace/ext/language_tools')

      var renderer = this.editor.renderer

      this.editor.setTheme('ace/theme/tomorrow')
      this.editor.setOptions({
        fontSize: '16pt',
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: false
      })
      this.editor.setShowPrintMargin(false)
      renderer.setPadding(8)
      // this.editor.getSession().setUseSoftTabs(false)
    },
    setSession: function (tabIndex) {
      // console.log('setSession', tabIndex)
      if (this.sessions[tabIndex]) {
        // console.log('update session')
        this.editor.setSession(this.sessions[tabIndex])
        this.editor.focus()
      } else {
        // console.log('create session')
        let session = this.createSession(tabIndex)
        this.editor.setSession(session)
        this.editor.focus()
      }
    },
    createSession: function (tabIndex) {
      let session = ace.createEditSession('code', 'ace/mode/javascript')
      session.setMode('ace/mode/javascript')
      session.setUseSoftTabs(true)
      session.setTabSize(2)
      // console.log('qq' + this.codefile)
      session.setValue(this.codefile.code)

      // disable some errors
      session.setUseWorker(false)
      // console.log(session)
      // session.$worker.emit('changeOptions', [{asi: true}])

      this.sessions[tabIndex] = session

      // here update the store
      session.on('change', (e) => {
        // event with modifications
        // console.log(Date.now())
        this.outputDebug.push({
          timestamp: Date.now(),
          m: e
        })

        // console.log('1 code change', session.getValue())
        this.codefile = session.getValue()
      })
      this.setMobileProperties(this.isMobile)

      return session
    },
    selectTab: function (index) {
      this.editor.setSession(this.sessions[index])
      this.editor.focus()
    }
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.editor-textarea-new {
  height: 100%;
  // padding-top: 10px;
  background: #272822;
}

#editor {
  height: 100%;
}

.debug {
  position: absolute;
  top: 0;
  right: 0;
}

/*
* TODO move it to a theme
*/
.ace_editor {
  line-height: 1.20em !important;
}

/*
.ace-monokai {
  // background-color: transparent !important;
}
.ace_gutter {
  background: transparent !important;
  color: rgba(255, 255, 255, 0.2) !important;
}

.ace_dark .ace_gutter-cell.ace_info {
  background-image: none;
}

.ace-tm .ace_marker-layer .run_code{
  background-color: rgba(0, 255, 0, 0.38);
  position: absolute;
  width: 100% !important;
  left: 0 !important;
  z-index: 25 !important;
}

.ace_editor.ace_autocomplete {
  border: 0px !important;
  border-radius: 2px 0px 0px 2px;
}

.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {
  background-color: @accentColor;
}
*/

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorTextareaAce.vue